export const AgentPlanningDashboard = [
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "attendance",
            "colorTheme": "colorTheme1",
            "title": "TODAY'S ATTENDANCE",
            "binding": {
                "data": {
                    "columns": [

                    ],
                    "title": '',
                    "endpoint": "R13",
                    "parameters": [
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "cyclePeriod",
            "colorTheme": 'colorTheme1',
            "title": "CURRENT CYCLE",
            "binding": {
                "data": {
                    "endpoint": "R14",
                    "parameters": []
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "advancedGuageDial",
            "colorTheme": 'colorTheme1',
            "title": "REMAINING CALLS TODAY",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "title": "Title",
                    "value": 'Progress',
                    "total": 'Total',
                    "endpoint": "R1",
                    "parameters": [
                        { "key": "start_date", "value": "2023-01-01" },
                        { "key": "end_date", "value": "2023-12-31" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "count",
            "colorTheme": 'colorTheme1',
            "title": "PENDING CALLS",
            "binding": {
                "data": {
                    "value": 'Pending',
                    "endpoint": "R2",
                    "parameters": []
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 4,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "advancedGuage",
            "colorTheme": 'colorTheme1',
            "title": "CALL RATE",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "title": "Title",
                    "value": 'Progress',
                    "total": 'Total',
                    "endpoint": "R3",
                    "parameters": [
                        { "key": "start_date", "value": "2023-01-01" },
                        { "key": "end_date", "value": "2023-12-31" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 4,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "advancedGuage",
            "colorTheme": 'colorTheme1',
            "title": "CALL REACH",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "title": "Title",
                    "value": 'Progress',
                    "total": 'Total',
                    "endpoint": "R4",
                    "parameters": [
                        { "key": "start_date", "value": "2023-01-01" },
                        { "key": "end_date", "value": "2023-12-31" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 4,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "advancedGuage",
            "colorTheme": 'colorTheme1',
            "title": "CALL FREQUENCY",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "title": "Title",
                    "value": 'Progress',
                    "total": 'Total',
                    "endpoint": "R5",
                    "parameters": [
                        { "key": "start_date", "value": "2023-01-01" },
                        { "key": "end_date", "value": "2023-12-31" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {}
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme3',
            "title": "INCIDENTAL CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        },
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R7",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Incidental Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R7.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme4',
            "title": "ADVANCED CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        }
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R8",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Advanced Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R8.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme5',
            "title": "RECOVERED CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        }
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R9",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Recovered Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R9.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    },
    {
        "columns": 3,
        "rows": 1,
        "visual": {
            "id": 1,
            "type": "bar",
            "colorTheme": 'colorTheme6',
            "title": "JOINT CALLS",
            "orientation": "vertical",
            "xAxis": "",
            "yAxis": "",
            "binding": {
                "data": {
                    "series": [
                        {
                            "name": 'Count',
                            "value": 'Value',
                            "type": 'column'

                        }
                    ],
                    "title": 'SubCycle',
                    "endpoint": "R10",
                    "parameters": [
                        { "key": "FromMonth", "value": "1" },
                        { "key": "FromYear", "value": "2025" },
                        { "key": "ToMonth", "value": "1" },
                        { "key": "ToYear", "value": "2025" },
                        { "key": "ConfigTypeCode", "value": "Y2025" }
                    ]
                },
                "context": {
                    "point": {
                        "onClick": {
                            "selectedValueColumn": "CycleIndex",
                            "selectedTitle": "",
                            "visual": [
                                {
                                    "columns": 12,
                                    "rows": 2,
                                    "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": 'colorTheme1',
                                        "title": "Joint Call Sessions",
                                        "binding": {
                                            "data": {
                                                "columns": [
                                                    {
                                                        "name": 'Status',
                                                        "columnName": 'Status',
                                                        "width": '120px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Account Name',
                                                        "columnName": 'AccountName',
                                                        "width": '250px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    },
                                                    {
                                                        "name": 'Date',
                                                        "columnName": 'SessionDate',
                                                        "width": '200px',
                                                        "align": "left",
                                                        "sortable": true,
                                                        "sum": false,
                                                    }
                                                ],
                                                "title": "AccountName",
                                                "endpoint": "R10.1",
                                                "parameters": [
                                                    { "key": "CycleIndex", "value": "" }
                                                ]
                                            },
                                            "context": {
                                                "point": {
                                                    "onClick": {}
                                                }
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
    }
]